import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

/**
 * 🔥 StreakCard — casino-grade retention, the ETHICAL slice: daily streaks,
 * milestone badges and a daily quest. No loss-chasing nudges, no fake
 * near-misses — the streak counts SHOWING UP, not losing money.
 */
export const StreakCard = ({ accountId }) => {
  const [data, setData] = useState(null);

  const refresh = useCallback(async () => {
    if (!accountId) return;
    try {
      const { data: d } = await api.get(`/streak/${encodeURIComponent(accountId)}`);
      setData(d);
    } catch { /* keep old */ }
  }, [accountId]);
  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 60000);
    return () => clearInterval(t);
  }, [refresh]);

  if (!accountId || !data) return null;
  const { streak_days, today, quest, badges } = data;
  const pct = Math.min(100, Math.round((quest.done / quest.target) * 100));
  return (
    <div data-testid="streak-card" className="rounded-lg border border-vts-line bg-vts-card p-3 mb-3 space-y-2">
      <div className="flex items-center gap-3 flex-wrap">
        <div className="flex items-baseline gap-1.5">
          <span className="text-2xl">🔥</span>
          <span data-testid="streak-days" className="text-xl font-bold text-amber-300 font-mono">{streak_days}</span>
          <span className="text-[10px] uppercase tracking-wider text-vts-silver/55 font-mono">day streak</span>
        </div>
        <div className="text-[10px] font-mono text-vts-silver/60">
          today: <span className="text-white font-bold">{today.trades}</span> trades ·{" "}
          <span className={today.net > 0 ? "text-vts-profit font-bold" : today.net < 0 ? "text-vts-loss font-bold" : "text-vts-silver/60"}>
            {today.net >= 0 ? "+" : "−"}${Math.abs(today.net).toFixed(2)}
          </span>
        </div>
      </div>
      <div data-testid="streak-quest" className="space-y-1">
        <div className="flex items-center justify-between">
          <span className="text-[9px] uppercase tracking-wider text-vts-silver/55 font-mono">
            📋 Daily quest: settle {quest.target} trades {quest.complete ? "— DONE ✅" : `(${quest.done}/${quest.target})`}
            {quest.complete && quest.green ? " · finished GREEN 💚" : ""}
          </span>
        </div>
        <div className="h-1.5 rounded-full bg-vts-surface overflow-hidden">
          <div className={`h-full rounded-full transition-all duration-700 ${quest.complete ? "bg-vts-profit" : "bg-amber-400"}`} style={{ width: `${pct}%` }} />
        </div>
      </div>
      {badges.length > 0 && (
        <div data-testid="streak-badges" className="flex gap-1.5 flex-wrap">
          {badges.map((b) => (
            <span key={b.id} className="text-[9px] font-mono px-1.5 py-0.5 rounded-full border border-vts-gold/40 bg-vts-gold/10 text-vts-gold">{b.label}</span>
          ))}
        </div>
      )}
      <p className="text-[8px] font-mono text-vts-silver/35">Streak counts showing up — a settled trade a day keeps it alive. It never rewards losing more.</p>
    </div>
  );
};

export default StreakCard;
